export default __webpack_public_path__ + "static/russian-5-92c1c44b9fd95a2ff3f5ea0403df817f.jpg";